// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_header__VUfVT {
	padding: 0px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: sticky;
	top: 0;
	width: 100%;
	z-index: 1000;
	background: linear-gradient(to right, #081b30, #222d38);
}
/* @media only screen and (max-width: 774px) {
	.header {
		height: auto;
	}
} */
`, "",{"version":3,"sources":["webpack://./src/assemblies/layout/layout.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,gBAAgB;CAChB,MAAM;CACN,WAAW;CACX,aAAa;CACb,uDAAuD;AACxD;AACA;;;;GAIG","sourcesContent":[".header {\n\tpadding: 0px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tposition: sticky;\n\ttop: 0;\n\twidth: 100%;\n\tz-index: 1000;\n\tbackground: linear-gradient(to right, #081b30, #222d38);\n}\n/* @media only screen and (max-width: 774px) {\n\t.header {\n\t\theight: auto;\n\t}\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `layout_header__VUfVT`
};
export default ___CSS_LOADER_EXPORT___;
